import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// TODO: should be changed for testing
const firebaseConfig = {
  apiKey: "AIzaSyAJ8w7h_uYOKzox2WKXyCMgc9qZlRcXfuU",
  authDomain: "cc-ks-04-flug.firebaseapp.com",
  projectId: "cc-ks-04-flug",
  storageBucket: "cc-ks-04-flug.firebasestorage.app",
  messagingSenderId: "276526588706",
  appId: "1:276526588706:web:5a6ba5a48acca7694a7b7b",
  measurementId: "G-XWE0SV7BYR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const functions = getFunctions(app, "europe-west3");

// Connect to emulator in development (set REACT_APP_USE_EMULATOR=true in .env.local)
if (process.env.REACT_APP_USE_EMULATOR === "true") {
  connectFunctionsEmulator(functions, "localhost", 5001);
  console.log("🧪 Using Functions Emulator");
}
